<script setup>
import routes from '@/constants/routes';
import analyticEventKeys from '@/constants/analytic-event-keys';

// logo scroll to top
const route = useRoute();
const analytics = useGoogleAnalytics();
const localeRoute = useLocaleRoute();

function handleLogoClick() {
  if (route.name === localeRoute('index').name) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  analytics.pushEvent({
    event: analyticEventKeys.MENU_NAVIGATE,
    label: routes.MAIN,
  });
}
</script>

<template>
  <div class="layout-form-search">
    <CTagDetect
      class="layout-form-search__link hidden-mobile"
      :to="routes.MAIN"
      aria-label="Rail Monsters"
      @click="handleLogoClick"
    >
      <CImage
        class="layout-form-search__logo"
        src="/icons/logo.svg"
        alt="Rail Monsters"
        loading="lazy"
      />
    </CTagDetect>

    <FormsSearch class="layout-form-search__form" />

    <div class="layout-form-search__buttons hidden-mobile">
      <ClientOnly>
        <BundlesAccountNavigationButtons />
      </ClientOnly>
    </div>
  </div>
</template>
